import React from 'react'
import 'App.css'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from "./pages/Login";
import Home from "./pages/Home";
import PrivateRouter from './routers/PrivateRouter';
import OrderList from 'pages/OrderList';
import Contactus from 'pages/Contactus';
import ProductList from 'pages/product/ProductList';
import AddProduct from 'pages/product/AddProduct';
import UpdateProduct from 'pages/product/UpdateProduct';

// gallery
// import GalleryList from 'pages/gallery/List';
// import GalleryAdd from 'pages/gallery/Add';
// import GalleryUpdate from 'pages/gallery/Update';

import PromoPopup from 'pages/promo/PromoPopup'


// banner
import BannerList from 'pages/banner/List';
import AddBanner from 'pages/banner/Add';
import UpdateBanner from 'pages/banner/Update';

// Our Team
import CreateBill from 'components/billing/CreateBill';

//users
import UsersList from 'pages/users/UsersList';
import UpdateUser from 'pages/users/UpdateUser';
import ListCustomer from 'pages/customer/ListCustomer';
import UpdateCustomer from 'pages/customer/UpdateCustomer';
import BillList from 'components/billing/BillList';
import BillDetails from 'components/billing/BillDetails';
import CorderList from 'pages/orderList/CorderList';
import CategoryList from 'pages/categories/CategoryList';
import AddCategory from 'pages/categories/AddCategory';
import SubcategoryList from 'pages/categories/SubcategoryList';
import AddSubcategory from 'pages/categories/AddSubcategory';
function App() {
  return (
    <Router>
      <>
        <Routes>
          <Route path="/signin" element={<Login />} />
          <Route path="/" element={<Login />} />
        </Routes>
      </>
      <Routes>
        <Route element={<PrivateRouter />}>
          <Route path="/dashboard" element={<Home />} />
          <Route path="/orderlist" element={<OrderList />} />
          <Route path="/contactus" element={<Contactus />} />
          <Route path="/products" element={<ProductList />} />
          <Route path="/products/add" element={<AddProduct />} />
          <Route path="/products/update/:id" element={<UpdateProduct />} />

          {/* gallery */}
          {/* <Route path="/gallery" element={<GalleryList />} />
          <Route path="/gallery/add" element={<GalleryAdd />} />
          <Route path="/gallery/update/:id" element={<GalleryUpdate />} /> */}

          {/* banner */}
          <Route path="/banner" element={<BannerList />} />
          <Route path="/banner/add" element={<AddBanner />} />
          <Route path="/banner/update/:id" element={<UpdateBanner />} />

          {/* user  */}
          <Route path="/users" element={<UsersList />} />
          <Route path="/users/update/:id" element={<UpdateUser />} />

          {/* billing */}
          <Route path="/billing" element={<CreateBill />} />
          <Route path="/billing-list" element={<BillList />} />
          <Route path="/billing/details/:id" element={<BillDetails />} />

          {/* Customer */}
          <Route path="/customer" element={<ListCustomer />} />
          <Route path="/customer/update/:id" element={<UpdateCustomer />} />

          {/* customer order list */}
          <Route path="/customerorder" element={<CorderList />} />
          <Route path="/categories" element={<CategoryList />} />
          <Route path="/categories/add" element={<AddCategory />} />
          <Route path="/subcategories" element={<SubcategoryList />} />
          <Route path="/subcategories/add" element={<AddSubcategory />} />
          <Route path="/*" element={<h1>No page avaliable</h1>} />


             <Route path="/promousers" element={<PromoPopup />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
